import {HiArrowDown} from "react-icons/hi2";
import { HiArrowUpRight } from "react-icons/hi2";
import {motion} from "framer-motion";
import React from "react";
import { Link } from 'react-router-dom';

export default function BottomHomepage(){
    return(
        <div>
            <motion.div
                variants={{
                    hidden: { opacity: 0, y: -50 },
                    visible: { opacity: 1, y: 0 }
                }}
                initial="hidden"
                whileInView="visible"
                transition={{duration: 0.6, delay: 0.4}}
                viewport={{once: false}}
            >
                <HiArrowDown className="text-6xl mx-auto"  />
            </motion.div>

            <Link to={"/stockholm/description"}>
                <motion.div
                    className="flex my-16"
                    variants={{
                        hidden: { opacity: 0, y: -50 },
                        visible: { opacity: 1, y: 0 }
                    }}
                    initial="hidden"
                    whileInView="visible"
                    transition={{duration: 0.6, delay: 0.8}}
                    viewport={{once: false}}
                >
                        <div className="mx-auto bg-gradient-to-r from-blue-400 to-pink-400 hover:bg-gradient-to-r hover:from-pink-400 hover:to-blue-400 rounded-full text-2xl text-white py-4 px-6 flex items-center justify-center">
                            <div>Learn More About BioGlimmer&nbsp;</div>
                            <HiArrowUpRight className="text-3xl" />
                        </div>
                </motion.div>
            </Link>
        </div>
    )
}